/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_USERS_BY_GROUP_FAILURE, FETCH_USERS_BY_GROUP_REQUEST, FETCH_USERS_BY_GROUP_SUCCESS, GET_ALL_USER_GROUPS, SET_SEARCH_VALUE_OF_USER_GROUP } from "./types";

export const getAllUserGroupsAction = (usersGroupsResponse: any) => {
  return {
    type: GET_ALL_USER_GROUPS,
    usersGroupsResponse,
  };
};

export const setUserGroupSearchValueAction = (searchValue: string) => {
  return {
    type: SET_SEARCH_VALUE_OF_USER_GROUP,
    searchValue,
  };
};

export const fetchUsersByGroupRequest = () => ({
  type: FETCH_USERS_BY_GROUP_REQUEST
});

export const fetchUsersByGroupSuccess = (usersByGroup: any, page: any) => {
  return {
    type: FETCH_USERS_BY_GROUP_SUCCESS,
    usersByGroup: usersByGroup,
    page: page
  };
};

export const fetchUsersByGroupFailure = (error: any) => ({
  type: FETCH_USERS_BY_GROUP_FAILURE,
  error
});
